import { Link } from "react-router-dom";

const PWC_LOGO = "/pwc-logo-secondary.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative">
      {/* Gold accent */}
      <div className="h-[3px] gold-accent" />

      {/* End of broadcast */}
      <div className="bg-[#0D0D0D] py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Sign-off header */}
          <div className="flex items-center gap-4 mb-12">
            <div className="segment-label">End of Broadcast</div>
            <div className="flex-1 h-[1px] bg-[#B09030]/20" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Logo & tagline */}
            <div className="flex flex-col items-start gap-4">
              <img src={PWC_LOGO} alt="PWC" className="h-16 w-auto" />
              <p className="font-body text-xs text-[#B09030]/60 uppercase tracking-[0.3em] mt-1">
                Return to Tradition
              </p>
              <p className="font-body text-sm text-[#E8DFC8]/25 mt-2 leading-relaxed">
                Old school professional wrestling,<br/>the way it was meant to be.
              </p>
            </div>

            {/* Navigation */}
            <div>
              <p className="font-heading text-xs text-[#B09030] mb-5 uppercase tracking-[0.2em]">Navigate</p>
              <div className="flex flex-col gap-2">
                {[
                  { to: "/", label: "Home" },
                  { to: "/locker-room", label: "Locker Room" },
                  { to: "/championships", label: "Titles" },
                  { to: "/shows", label: "Shows" },
                  { to: "/dirt-sheets", label: "Dirt Sheets" },
                  { to: "/about", label: "About" },
                  { to: "/merch", label: "Merch" },
                  { to: "/sponsors", label: "Sponsors" },
                  { to: "/gallery", label: "Gallery" },
                  { to: "/contact", label: "Contact" },
                ].map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="font-body text-sm text-[#E8DFC8]/30 hover:text-[#B09030] transition-colors uppercase tracking-wider"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <p className="font-heading text-xs text-[#B09030] mb-5 uppercase tracking-[0.2em]">The Territory</p>
              <p className="font-body text-sm text-[#E8DFC8]/30 leading-relaxed mb-4">
                Piedmont Wrestling Club is a professional wrestling promotion
                bringing territory-style wrestling back to the Piedmont region.
              </p>
              <a
                href="mailto:Piedmontwrestlingclub@Gmail.com"
                className="font-body text-xs text-[#B09030]/80 hover:text-[#B09030] transition-colors uppercase tracking-wider block"
              >
                Piedmontwrestlingclub@Gmail.com
              </a>
              <div className="flex items-center gap-4 mt-4">
                <a
                  href="https://facebook.com/Piedmontwrestlingclub"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-facebook"
                  className="font-body text-xs text-[#E8DFC8]/40 hover:text-[#B09030] transition-colors uppercase tracking-wider"
                >
                  Facebook
                </a>
                <span className="text-[#E8DFC8]/15">|</span>
                <a
                  href="https://instagram.com/Piedmontwrestlingclub"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="social-instagram"
                  className="font-body text-xs text-[#E8DFC8]/40 hover:text-[#B09030] transition-colors uppercase tracking-wider"
                >
                  Instagram
                </a>
              </div>
              <div className="mt-6 h-[2px] w-12 gold-accent" />
            </div>
          </div>

          <div className="mt-16 pt-6 border-t border-[#E8DFC8]/5 flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="font-body text-[10px] text-[#E8DFC8]/15 uppercase tracking-[0.3em]">
              &copy; {new Date().getFullYear()} Piedmont Wrestling Club &bull; All Rights Reserved
            </p>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="font-body text-[10px] text-[#E8DFC8]/10 hover:text-[#E8DFC8]/30 transition-colors uppercase tracking-[0.3em]"
            >
              Front Office
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
